import React, { useState, useEffect } from 'react'
import {
    Button, Flex, Table, Drawer,
    Input, Upload, Card, Tag, Skeleton, Breadcrumb,
    Tabs,
    Badge
} from 'antd'
import api from '../../../service/axios'
import { useToasts } from 'react-toast-notifications';
import {
    UploadOutlined,
    FileTextOutlined,
    LoadingOutlined,
    SendOutlined,
    SearchOutlined,
    FilePdfOutlined,
    UserOutlined,
    BankOutlined
} from '@ant-design/icons';
import { userState } from '../../../service/database'
import { useRecoilState } from 'recoil'
import dayjs from 'dayjs';
import { CRTNova } from './crtNova'
import LOGO from '../../../images/logomarca_CRQ.png'
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import FileViewer from '../../../componentes/fileViewer'
import { BASEURL } from '../../../service/axios'


export const CRT = (props) => {

    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const [msg, setMsg] = useState('')
    const { addToast } = useToasts()
    const [dataSolicitacoes, setDataSolicitacoes] = useState(undefined)
    const [user,] = useRecoilState(userState)
    const [selected, setSelected] = useState(undefined)
    const [openSelected, setOpenSelected] = useState(false)
    const [arquivos, setArquivos] = useState([])
    const [arquivoSelecionado, setArquivoSelecionado] = useState(null)

    useEffect(() => {
        if (user?.isprofissional === 1)
            crqSolicitacoes()
        else
            navigate('/login')
    }, [])


    async function crqSolicitacoes() {
        try {
            setLoading(true)
            const result = await api.get('/api/v1.0/registrado/crt',
                {
                    headers: {
                        'x-access-token': user?.token2
                    }
                }
            )
            setDataSolicitacoes(result.data)
        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }
        setLoading(false)
    }

    async function crqSolicitacao(id) {
        try {
            setLoading2(true)
            const result = await api.get('/api/v1.0/registrado/crt/id',
                {
                    headers: {
                        'x-access-token': user?.token2
                    },
                    params: {
                        id: id
                    }
                })

            setSelected(result.data)          

        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }
        setLoading2(false)
    }



    function renderStatus(item) {
        switch (item.etapa) {
            case 10: return <Tag color={'pink'}>Documentação conferida</Tag>
            case 0: return <Tag color={'blue'}>Rascunho <span style={{ fontSize: '0.8em' }}>(etapa 1)</span></Tag>
            case 1: return <Tag color={'blue'}>Rascunho <span style={{ fontSize: '0.8em' }}>(etapa 2)</span></Tag>
            case 2: return <Tag color={'blue'}>Rascunho <span style={{ fontSize: '0.8em' }}>(etapa 3)</span></Tag>
            case 3: return <Tag color={'blue'}>Rascunho <span style={{ fontSize: '0.8em' }}>(etapa 4)</span></Tag>
            case 4: return <Tag color={'cyan'}>Em analise </Tag>
            case 5: return <Tag color={'geekblue'}>Aguardando Plenária</Tag>
            case 6: return <Tag color={'green'}>Aprovada</Tag>
            case 7: return <Tag color={'red'}>Baixada em Diligência</Tag>
            case 8: return <Tag color={'volcano'}>Pendência</Tag>
            case 9: return <Tag color={'lime'}>Em Reanálise</Tag>

            default:
                return;
        }


    }

    function renderSolicitacoes() {
        return <Flex vertical gap={5}>

            <Table id='tablesmall' size='small' loading={loading} bordered pagination={false} dataSource={dataSolicitacoes}>
                <Table.Column hidden={isMobile} title={"Protocolo"} align='center' render={(txt, item, index) => {
                    return <Badge size='small' count={item.datamsg?.filter(v => v.lida === 0 && v.autor === 0)?.length}> {String(item.id).padStart(4, '0')} </Badge>
                }} />

                <Table.Column title={"Data"} align='center' render={(txt, item, index) => {
                    return dayjs(item.criadaem).format('DD.MM.YYYY HH:mm')
                }} />

                <Table.Column title={"Razão Social"} render={(txt, item, index) => {
                    return item.razao
                }} />
                <Table.Column hidden={isMobile} title={"CNPJ"} render={(txt, item, index) => {
                    return item.cnpj
                }} />

                <Table.Column hidden={isMobile} title={"Atividade"} render={(txt, item, index) => {
                    return item.atividade
                }} />
                <Table.Column title={"Status"} align='center' render={(txt, item, index) => {

                    return renderStatus(item)
                }} />

                <Table.Column title={""} render={(txt, item, index) => {
                    return <Button size='small' type='link' icon={<SearchOutlined />}
                        onClick={async () => {
                            try {
                                setLoading(true)
                                await crqSolicitacao(item.id)
                                setOpenSelected(true)

                            } catch (error) {
                                addToast(error.message, {
                                    autoDismiss: true,
                                    appearance: 'error'
                                })
                            }
                            setLoading(false)
                        }} />
                }} />

            </Table>
        </Flex>
    }


    return <Flex vertical gap={10}>
        <Flex align='center' justify='space-between'>
            <Breadcrumb items={[
                {
                    title: <Flex align='center' gap={5}><FileTextOutlined /> Comunicações de Responsabilidade Técnica</Flex>,
                }, {
                    title: "Solicitações"
                }
            ]} />

            <Button type='primary' style={{ width: 90 }} size='small' icon={<FileTextOutlined />} onClick={() => {

                setSelected({
                    aceite: 0,
                    crq: user?.crq,
                    etapa: 0,
                    vinculo: 0,
                    nome: user?.nome,
                    cpf: user?.cpf,
                    cnpj: '',
                    horas: '',
                    atividade: "",
                    respfinanceiro: 0,
                    status: false

                })

                setOpenSelected(true)
                console.log(selected)

            }}>Nova</Button>

        </Flex>

        {renderSolicitacoes()}

        {
            selected && (selected.etapa > 3) && <Drawer
                size={isMobile ? '100%' : '80%'}
                open={openSelected}
                destroyOnHidden={true}
                title={<Flex >
                    <Flex flex={1}>{"CRT - Protocolo ".concat(String(selected.id).padStart(4, '0'))}</Flex>
                    <Flex align='center' gap={5} style={{ fontStyle: 'normal' }}>
                        <Flex> {renderStatus(selected)}</Flex>
                    </Flex>
                </Flex>}
                closable={true}
                onClose={() => {
                    setOpenSelected(false)
                    crqSolicitacoes()
                }}
                footer={
                    null
                }>


                <Tabs
                    onChange={async (v) => {
                        try {
                            if (v === '2') {
                                await api.put('/api/v1.0/registrado/crt/msg/lida', { id: selected?.id },
                                    {
                                        headers: {
                                            'x-access-token': user?.token2
                                        }
                                    }
                                )
                            }
                            crqSolicitacao(selected?.id)
                        } catch (error) {

                        }
                    }}
                    size='small'
                    items={[
                        {
                            key: '5',
                            label: <Flex align='center' gap={10}>Dados</Flex>,
                            children: <Flex vertical gap={15}>
                                <Card size='small' style={{ backgroundColor: 'white' }}>
                                    <Flex vertical>
                                        <Flex>
                                            <Flex align='center' gap={5} flex={1}>
                                                <Flex><b>Data: </b></Flex>
                                                <Flex> {dayjs(selected.atualizadaem ? selected.atualizada : selected.criadaem).format('DD/MM/YYYY HH:mm')}</Flex>
                                            </Flex>

                                        </Flex>
                                        <Flex align='center'>

                                            <Flex align='center' gap={5} flex={1}>
                                                <Flex><b>Razão Social: </b></Flex>
                                                <Flex> {selected.razao}</Flex>
                                            </Flex>

                                            <Flex align='center' gap={5} flex={1}>
                                                <Flex><b>CNPJ: </b></Flex>
                                                <Flex> {selected.cnpj}</Flex>
                                            </Flex>

                                        </Flex>
                                        <Flex align='center' gap={5} >
                                            <Flex><b>Endereço: </b></Flex>
                                            <Flex> {selected.endereco} {selected.bairro}, {selected.cidade}</Flex>
                                        </Flex>

                                        <Flex align='center' gap={5} flex={1}>
                                            <Flex><b>Atividade: </b></Flex>
                                            <Flex> {selected.atividade}</Flex>
                                        </Flex>


                                        <Flex align='center' gap={5} flex={1}>
                                            <Flex><b>Dias e Horários: </b></Flex>
                                            <Flex> {selected.horas}</Flex>
                                        </Flex>






                                    </Flex>
                                </Card>

                                <Flex vertical flex={1}>
                                    <Card size='small' type='inner' title={<Flex gap={10}>
                                        <BankOutlined />
                                        Outras Empresas de Minha Responsabilidade Técnica
                                    </Flex>}>
                                        <Flex vertical>
                                            <Table dataSource={selected?.outras} bordered size='small'
                                                styles={{
                                                    header: {
                                                        row: {
                                                            fontSize: '0.9em'
                                                        },

                                                    },
                                                    body: {
                                                        row: {
                                                            fontSize: '0.9em'
                                                        },

                                                    }
                                                }}>
                                                <Table.Column title={"Razão"} render={(txt, item, index) => {
                                                    return <Flex vertical>
                                                        <Flex>{item.razao}</Flex>
                                                        <Flex style={{ fontSize: '0.9em', fontStyle: 'italic' }}>{item.cnpj}</Flex>
                                                    </Flex>
                                                }}

                                                />
                                                <Table.Column title={"Horário"} render={(txt, item, index) => {
                                                    return <Flex align='center'>{item.horarios}</Flex>

                                                }}

                                                />
                                            </Table>
                                        </Flex>
                                    </Card>

                                </Flex>


                            </Flex>
                        },
                        {
                            key: '1',
                            label: <Flex align='center' gap={10}>Arquivos</Flex>,
                            children: <Flex vertical={isMobile ? true : false}>
                                <Flex flex={1} gap={60} style={{ minHeight: '70vh' }} vertical={isMobile ? true : false}>
                                    <Flex gap={15}>
                                        <Flex flex={1} vertical>
                                            <Flex flex={1} vertical>
                                                <Table size='small'
                                                    styles={{
                                                        header: {
                                                            backgroundColor: 'whitesmoke'
                                                        },
                                                        titl: {
                                                            backgroundColor: 'whitesmoke'
                                                        }
                                                    }}
                                                    showHeader={false} bordered dataSource={selected?.files} pagination={false}
                                                    style={{ width: 200, }}
                                                    title={() => <Flex><b>Arquivos da Solicitação</b></Flex>}>
                                                    <Table.Column render={(txt, item, index) => {
                                                        return <Button size='small' type='link' onClick={async () => {
                                                            try {
                                                                setArquivoSelecionado(item.url)
                                                            } catch (error) {
                                                                console.log(error.message)
                                                                addToast(error.message, { autoDismiss: true, appearance: 'error' })
                                                            }

                                                        }}> {item.label} </Button>
                                                    }} />
                                                </Table>
                                            </Flex>

                                            {(selected?.status === 9 || selected?.status === 7 || selected?.status === 8) && selected?.files?.length < 8 && <Upload {...props}
                                                onRemove={async (file) => {
                                                    setLoading(true)
                                                    try {
                                                        /*
                                                        await api.delete('api/v1.0/upload/files/upload',
                                                            {
                                                                headers: {
                                                                    'x-access-token': user?.token2
                                                                },
                                                                params: {
                                                                    id: selected.id
                                                                }
                                                            }
                                                        )
                                                        */
                                                    } catch (error) {
                                                        addToast(error.message, { appearance: 'error', autoDismiss: true })
                                                    }
                                                    setLoading(false)
                                                }}
                                                headers={
                                                    {
                                                        'x-access-token': user?.token2,
                                                    }
                                                }
                                                name="file"
                                                maxCount={1}
                                                showUploadList={false}
                                                data={{ ...selected }}
                                                action={BASEURL.concat('api/v1.0/upload/files/upload')}
                                                beforeUpload={async (file) => {
                                                    const isJpgOrPng = file.type === 'application/pdf';
                                                    let isLt2M = file.size / 1024 / 1024 / 1024 / 1024 / 1024 < 5;
                                                    try {
                                                        if (!isJpgOrPng) {
                                                            console.log('Você só pode fazer upload de documentos no formato PDF!')
                                                            addToast('Você só pode fazer upload de documentos no formato PDF!', { appearance: 'error', autoDismiss: true });
                                                        }
                                                        if (!isLt2M) {
                                                            addToast('O documento não poder ser maior que 5mb!', { appearance: 'error', autoDismiss: true });
                                                        }
                                                    } catch (error) {
                                                        isLt2M = false
                                                    }
                                                    return isJpgOrPng && isLt2M;
                                                }}

                                                onChange={(info) => {
                                                    if (info.file.status === 'uploading') {
                                                        setLoading(true)
                                                        return;
                                                    }
                                                    if (info.file.status === 'done') {
                                                        setLoading(false)
                                                        crqSolicitacao(selected?.id)
                                                    }
                                                    if (info.file.status === 'error') {
                                                        addToast(info?.file.response?.error, { autoDismiss: true, appearance: 'error' })
                                                        info.fileList.pop()
                                                        setLoading(false)
                                                        return;
                                                    }
                                                    if (info.file.status === undefined) {
                                                        setLoading(false)
                                                        info.fileList.pop()
                                                        return;
                                                    }

                                                }}
                                                onPreview={() => {
                                                }}
                                            >
                                                <Button icon={<UploadOutlined />}>Anexar arquivo</Button>
                                            </Upload>
                                            }

                                        </Flex>
                                    </Flex>
                                    <Flex flex={1} >
                                        <FileViewer url={arquivoSelecionado} id={selected?.id} />
                                    </Flex>
                                </Flex>
                            </Flex>
                        },
                        {
                            key: '2',
                            label: <Flex align='center' gap={10}> <Badge size='small' count={selected?.msgs?.filter(v => v.lida === 0 && v.autor === 0)?.length}> Chat </Badge></Flex>,
                            children: <Flex vertical>
                                {loading2 && <Flex gap={5} align='center'> <Skeleton active /> </Flex>}

                                {selected?.msgs?.length === 0 && <Flex style={{ fontStyle: 'italic', color: 'darkgrey' }}> Nada por aqui por enquanto!</Flex>}
                                {selected?.msgs?.map((item2, index) => {
                                    return <Flex id={'id:'.concat(index)} style={{ padding: 0, marginTop: 5 }} >

                                        <Tag color={item2.autor === 1 ? 'default' : 'blue'} style={{ marginLeft: 10, width: '100%' }}>
                                            <Flex vertical>
                                                <Flex justify='space-between' align='center' gap={50}>
                                                    <Flex align='center' gap={5}>
                                                        {item2.autor === 0 ? <Flex align='center' gap={5}>
                                                            <img src={LOGO} height={15} width={15} alt='logo' />
                                                            <b> CRQ10/CE </b>
                                                        </Flex> :
                                                            <Flex align='center' gap={5}>
                                                                <UserOutlined />
                                                                <b> {user?.nome} </b>
                                                            </Flex>
                                                        }

                                                    </Flex>

                                                    <Flex style={{ fontSize: '0.8em', fontWeight: 700 }} gap={0}>
                                                        {dayjs().format('DD/MM/YYYY') === dayjs(item2.createat).format('DD/MM/YYYY') ? 'Hoje ' : dayjs(item2.createat).format('DD/MM/YY').concat(' ')}
                                                        {dayjs(item2.createat).format('HH:mm')}
                                                        <Flex>hs </Flex>
                                                    </Flex>

                                                </Flex>


                                                <Flex style={{ fontStyle: 'italic', color: '#333232' }}> {item2.msg}</Flex>
                                            </Flex>
                                        </Tag>
                                    </Flex>
                                })}

                                <Flex gap={10} justify='flex-end' style={{ marginTop: 15, marginLeft: 10 }}>
                                    <Input
                                        placeholder='Sua mensagem'
                                        value={msg}
                                        onChange={(e) => setMsg(e.target.value)} />
                                    <Button
                                        icon={<SendOutlined />}
                                        disabled={msg.trim().length === 0}
                                        loading={selected?.loading}
                                        type='primary'
                                        onClick={async () => {
                                            enviarMsg(msg)
                                        }}>
                                        Enviar </Button>
                                </Flex>


                            </Flex>
                        }


                    ]}>

                </Tabs>




            </Drawer>
        }

        {

            selected && (selected.etapa <= 3) && <Drawer
                size={isMobile ? '100%' : '80%'}
                open={openSelected}
                destroyOnHidden={true}
                title={null}
                closable={false}
                onClose={() => {
                    setOpenSelected(false)
                    crqSolicitacoes()
                }}
                footer={null}>
                <CRTNova setOpenSelected={setOpenSelected} selected={selected} crqSolicitacoes={crqSolicitacoes} />

            </Drawer>

        }

    </Flex>



    async function enviarMsg(txt) {
        try {
            setSelected({ ...selected, loading: true })
            await api.put('/api/v1.0/registrado/crt/msg', { autor: 1, msg: txt, id: selected.id },
                {
                    headers: {
                        'x-access-token': user?.token2
                    }
                }
            )
            setMsg('')
            let aux = { ...selected }
            aux.msgs.push({
                autor: 1,
                msg: txt,
                createat: dayjs().format('YYYY-MM-DD HH:mm')
            })
            setSelected(aux)
            setMsg('')

        } catch (error) {
            addToast(error.message, {
                autoDismiss: true, appearance: 'error'
            })
        }
        setSelected({ ...selected, loading: false })
    }
}